module.exports = __webpack_public_path__ + "img/top_icon05.6bd9391.png";